import { initializeApp } from "firebase/app";
import { 
  initializeAuth, 
  indexedDBLocalPersistence, 
  browserLocalPersistence, 
  browserSessionPersistence, 
  browserPopupRedirectResolver, 
  GoogleAuthProvider 
} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBinFtJlXsG8lHOMeKpTkDyEXv_JPaUTVU",
    authDomain: "carebridge-7c2f5.firebaseapp.com",
    projectId: "carebridge-7c2f5",
    storageBucket: "carebridge-7c2f5.firebasestorage.app",
    messagingSenderId: "64154778082",
    appId: "1:64154778082:web:bfbb39d7214ec97907e1bb",
    measurementId: "G-X6RLKE2RSD"
};

const app = initializeApp(firebaseConfig);

// Enable resilient multi-tiered persistence handling for iOS Safari, PWA standalone, and third-party storage restrictions
export const auth = initializeAuth(app, {
    persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence],
    popupRedirectResolver: browserPopupRedirectResolver
});

export const googleProvider = new GoogleAuthProvider();

